import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { Icon, Table } from "semantic-ui-react";

import "components/TableView/TableView.scss";

type TableViewProps = {
  cells: string[];
  nrOfCells: number;
  enableCopy?: boolean;
};

export const TableView = ({ cells, nrOfCells, enableCopy }: TableViewProps) => {
  const { t } = useTranslation();

  const tableRows = [];

  const handleCopy = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      toast.success(t("v8_copy_to_clipboard", "Copied to clipboard"));
    } catch (err) {
      console.error("Something went wrong, cannot copy the value", err);
    }
  };

  for (let i = 0; i < cells.length; i += nrOfCells) {
    let cellsToRender = cells.slice(i, nrOfCells + i);
    if (cellsToRender.length < nrOfCells) cellsToRender = cellsToRender.concat(Array(nrOfCells - cellsToRender.length).fill(""));

    tableRows.push(
      <Table.Row key={cells[i]}>
        {cellsToRender.map(cell => (
          <Table.Cell
            content={
              cell ? (
                <div className="table-view-row">
                  {enableCopy && (
                    <div className="clipboard-copy" onClick={() => handleCopy(cell)}>
                      <Icon className="copy" />
                    </div>
                  )}
                  <p>{cell}</p>
                </div>
              ) : (
                ""
              )
            }
            key={cell}
          />
        ))}
      </Table.Row>
    );
  }

  return (
    <div className="TableView">
      <Table celled>
        <Table.Body>{[...tableRows]}</Table.Body>
      </Table>
    </div>
  );
};
